import React, { ChangeEvent, useState } from 'react';
import { TextField, Grid } from '@mui/material';
import { blue } from '@mui/material/colors';

interface ComponentProps {
  // placeholder: string;
  label: string;
  instructions?: string;
  value: string;
  disabled?: boolean;
  onChange?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
}

type Props = ComponentProps;
//------------------------------------------------------------------------------
export const EvalTextField: React.FC<Props> = (props) => {
  const {
    // placeholder,
    instructions,
    disabled = false,
  } = props;

  const [value, setValue] = useState<string>(props.value);

  const onChange: React.ChangeEventHandler<
    HTMLInputElement | HTMLTextAreaElement
  > = (event: ChangeEvent<HTMLInputElement>) => {
    props.onChange?.(event);
    setValue(event.target.value);
  };
  return (
    <Grid container sx={{ py: 1, backgroundColor: blue[50] }}>
      <Grid item xs={1.2} sx={{ textAlign: 'left', minWidth: '5em' }}>
        <b>Provider: </b>
      </Grid>
      <Grid item xs={10.8}>
        <TextField
          autoComplete='off'
          fullWidth
          sx={{ px: 1, width: '100%' }}
          color='primary'
          id='evalText'
          label={instructions}
          disabled={disabled}
          multiline
          rows-={3}
          variant='outlined'
          value={value}
          onChange={onChange}
        />
      </Grid>
    </Grid>
  );
};
